var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.5H6.25V8.75H3.75V7.5ZM7.5 7.5H16.25V8.75H7.5V7.5ZM3.75 10H6.25V11.25H3.75V10ZM7.5 10H16.25V11.25H7.5V10ZM3.75 12.5H6.25V13.75H3.75V12.5ZM7.5 12.5H16.25V13.75H7.5V12.5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.25V18.75H20V1.25H0ZM18.75 17.5H1.25V5H18.75V17.5ZM18.75 3.75H17.5V2.5H18.75V3.75Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlan);
export default ForwardRef;